export default __webpack_public_path__ + "static/media/480_portfolio03-nl-web.00d6f060.png";